import { toHaveDisplayValue } from '@testing-library/jest-dom/dist/matchers';
import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';

import { apiHost } from './APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Doctor Summary. The Service is unavailable. Please try after sometime." };

export default class DoctorPayableStore {

    state = PENDING;
    regState = PENDING;

    message = EMPTY_MESSAGE;
    payables = [];
    totalIcPayable = 0;
    collectionType = '';

    sidCode = "";
    registrationId = 0;

    registration = [];

    rowCount = 0;

    buckets = new Set();

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.referrerId = props.referrerId;
        this.collectionType = props.collectionType;

        makeObservable(this, {
            state: observable,
            regState: observable,

            message: observable,
            payables: observable,
            rowCount: observable,
            totalIcPayable: observable,

            registration: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,
            canGenerate: computed,

            fetchSummary: action,
            fetchRegistration: action,
            generateInvoice: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    get canGenerate() {
        return this.collectionType !== "unknown" && this.rowCount > 0;
    }

    generateInvoice = async() => {
        if(this.collectionType === "unknown") {
            return;
        }
        if(this.rowCount === 0) {
            return;
        }

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const apiEndpoint = `${erpApiurl}api/Carbon/GenerateICInvoice`;

        try {
            const postables = this.getPostables();

            await this.apiProxy.asyncPost(apiEndpoint, postables);
            await this.fetchSummary(this.collectionType);
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    getPostables = () => {
        const bucketArr = [];
        for (const entry of this.buckets.values()) {
            bucketArr.push(entry);
        }
        return { "ReferrerId": this.referrerId, "invoiceType": this.collectionType, "buckets": bucketArr};
    }



   
    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchSummary = async (collectionType) => {

        const url = `${erpApiurl}api/Carbon/GetIcDoctorSummary?ReferrerId=${this.referrerId}&collectionType=${collectionType}`;

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;
        this.collectionType = collectionType;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
            this.payables = data;
            
            this.totalIc = 0;
            let ic = 0;
            
            this.buckets.clear();

            data.map((docpayable) => 
            {
                this.buckets.add(docpayable.Bucket);
                ic = ic + docpayable.IC;
            });

            this.rowCount = this.buckets.size;
            this.totalIcPayable = ic;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE;
        }
    }

     /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchRegistration = async (registrationId,sidCode) => {

        const url = `${erpApiurl}api/Carbon/GetIcSidBreakup?RegistrationId=${registrationId}`;

        this.regState = PENDING;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.regState = DONE;
                return;
            }
            this.sidCode = sidCode;
            this.registrationId = registrationId;
            this.registration = data;
            this.regState = DONE;
        }
        catch (e) {
            this.regState = ERROR;
        }
    }
}
